import type { UserStatus } from '../enums/user-status.enum.js'

/** What removing a client account amounts to, given whether it was ever used. */
export type ClientRetirement = 'delete' | 'deactivate'

/**
 * Deleting an event can take its client contacts with it, and the two kinds of
 * contact need different endings.
 *
 * An invitation nobody accepted should be deleted: the row is for someone who
 * never arrived, and the email column is unique, so keeping it holds that address
 * hostage — a mistyped invite could never be re-sent to the corrected one. An
 * account someone has used is deactivated instead: every relation on a user
 * cascades, so deleting it would take their work with it, and deactivation is the
 * reversible answer.
 *
 * This is the same rule the users list applies to a single person; it lives here
 * so the confirmation dialog can promise exactly what the server will do.
 */
export function clientRetirementFor(status: UserStatus): ClientRetirement {
  return status === 'PENDING' ? 'delete' : 'deactivate'
}
